import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'

/**
 * Returns villas pricing from cheapest selected package option
 * @returns [totalPrice, value, discount]
 */
function useVillasPrice(
  packageView: OfferPackageOptionView,
): [{ hotel: number, member: number }, number, number] {
  const showValue = packageView.hotelValue > packageView.hotelTotal && packageView.package.shouldDisplayValue
  const showDiscountPill = packageView.hotelDiscountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const value = showValue ? packageView.hotelValue : 0
  const discount = showDiscountPill ? packageView.hotelDiscountPercent : 0
  return [
    { hotel: packageView.hotelTotal, member: packageView.hotelMemberTotal },
    value,
    discount,
  ]
}

export default useVillasPrice
